export default __webpack_public_path__ + "static/media/ic_alp_40_1.2d66b102.svg";